import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import {Typography} from "@mui/material";

const RoadHeading = styled(Container)`
    background-color:#000B29;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    @media (min-width: 1400px){
        padding-top:50px;
        padding-bottom:50px;
    }
`
const RoadWrapper = styled(Container)`
    background-color:#000B29;
    padding-top:50px;
    display:flex;
    justify-content:center;
    @media (min-width: 601px){
        display:none;
    }
`
const Heading = styled(Typography)`
    font-size:25px;
    font-family:Emulogic-zrEw;
    font-weight:400;
    text-transform:uppercase;
    color:#fff;
`
const BoxWrapperGrid = styled(Grid)`
    background-image:url("./assets/box-bg.png");
    padding:30px;
    background-size: 100% 100%;
    background-repeat:no-repeat;
    margin:0px 10px;
    font-size:14px;
    padding-top:70px;
    padding-bottom:70px;
    margin-bottom:20px;
`
const BoxHeading = styled(Typography)`
    color:#fff;
    font-family:Emulogic-zrEw;
    font-weight:400;
    font-size:16px;
    margin:10px 0px;
    text-align:left;
`
const P = styled.p`
    color:#fff;
    font-family:Poppins;
    font-size:14px;
    text-align:left;
`
const WrapperGrid = styled(Grid)`
    padding-bottom:100px;
    @media(max-width: 2000px) and (min-width: 1400px){
        padding-bottom:120px;
    }
`
const HeadingGrid = styled(Grid)`
    padding-top:20px;
`
const RoadMapGrid = styled(Grid)`
    padding-top:60px;
    padding-bottom:100px;
    @media (max-width: 600px){
        display:none;
    }
`
const RoadMapimg = styled.img`
    width:100%;
`
function RoadMap(){
    return(
        <>
        <RoadHeading maxWidth="xxl" id="roadmap">
            <Grid container item xs={12} xl={10}>
                <HeadingGrid item xs={12}>
                    <Heading variant="h1">Roadmap</Heading>
                </HeadingGrid>
                <RoadMapGrid item xs={12}>
                    <div><RoadMapimg src="./assets/roadmap.png" /></div>
                </RoadMapGrid>
            </Grid>
        </RoadHeading>
        <RoadWrapper maxWidth="xxl">
            <WrapperGrid container item xs={12}>
                <BoxWrapperGrid item xs={12}>
                    <div>
                        <BoxHeading>Phase 1</BoxHeading>
                        <P>Game Development and Smart Contract Setup
                        </P>
                    </div>
                </BoxWrapperGrid>
                <BoxWrapperGrid item xs={12}>
                    <div>
                        <BoxHeading>Phase 3</BoxHeading>
                        <P>Launching Pacman on Mainnet and Initial Token Distribution
                        </P>
                    </div>
                </BoxWrapperGrid>
                <BoxWrapperGrid item xs={12}>
                    <div>
                        <BoxHeading>Phase 2</BoxHeading>
                        <P>Token Integration and Testing
                        </P>
                    </div>
                </BoxWrapperGrid>
                <BoxWrapperGrid item xs={12}>
                    <div>
                        <BoxHeading>Phase 4</BoxHeading>
                        <P>Continuous Improvement and Expansion
                        </P>
                    </div>
                </BoxWrapperGrid>
            </WrapperGrid>
        </RoadWrapper>
        </>
    );
}

export default RoadMap;